import React from 'react';
import { IconProps } from './model/IconInterface';

const EuroIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M18.5 5.5A8 8 0 0 0 6.5 12a8 8 0 0 0 12 6.5" /><line x1="3" y1="10" x2="13" y2="10" /><line x1="3" y1="14" x2="12" y2="14" />
    </svg>
  );
};

export default EuroIcon;
